import React, { useState, useEffect } from 'react';
import lodash from 'lodash';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import {
    loginError, setPasswordResetEmailSent,
    ssoSettingPin,
    fetchSignUrl,
    getSigningDetails,
    keymasterSign
} from '../../actions/login';
import LoginLayout from './LoginLayout';
import styles from './Login.scss';
import { Spinner } from '../../../components/common/LoadingStatus/LoadingStatus';


const NewUserRegistrationTasks = (props) => {
    const { loginErrorState, setPasswordResetEmailSent, keymasterSign } = props;

    const [email, setEmail] = useState(props.email);
    const [password, setPassword] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [passwordType, setPasswordType] = useState(true);
    const [loading, setLoading] = useState(true);
    const [invalidUrlError, setInvalidURlError] = useState('');
    const [signingSessionId, setSigningSessionId] = useState('');


    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);

                let signInUrl = await fetchSignUrl(props.accessToken);
                // eslint-disable-next-line no-useless-escape
                signInUrl = signInUrl.provider_uri.replace(/^https?:\/\/[^\/]+\//, '') + '&api=true';
                const signingDetails = await getSigningDetails(signInUrl);
                setSigningSessionId(signingDetails.session);
            }
            catch (e) {
                setInvalidURlError('Something went wrong, please try again !');
            }
            finally {
                setLoading(false);
            }

        };

        fetchData();
    }, []);

    useEffect(() => {
        setPasswordResetEmailSent(false);
    }, []);


    const onSubmitClick = async (e) => {
        try {
            e.preventDefault();

            if (password === '') {
                setPasswordError('Please enter your password.');
                return;
            }
            const signResponse = await keymasterSign({ sessionId: signingSessionId, email: props.email, password });
            if (signResponse.error && signResponse.error.includes('Incorrect password')) {
                setPasswordError(signResponse.error);
                return;
            }
            if (!signResponse.token && !signResponse.state) {
                setInvalidURlError('Something went wrong. Please try again!');
                return;
            }
            props.handleAction(signResponse.token);
            setPassword('');
            setPasswordError('');
        }
        catch (e) {
            setInvalidURlError('Something went wrong while completing the task.');
        }

    };



    const togglePasswordVisibility = () => {
        setPasswordType(!passwordType);
    };

    if (loading) {
        return (
            <div className={styles.Loader}>
                <Spinner actionLabel={'Loading'} itemName={''} />
            </div>
        );
    }
    return (
        <LoginLayout>
            {invalidUrlError ? <div className={styles.invalidUrl}>
                <div className={styles.complionSubTitle} style={{ color: 'red' }}>{invalidUrlError}</div>
            </div> :
                <div>
                    <div className={styles.complionTitle} style={{ marginBottom: '20px' }}>
                        {props.header}
                    </div>
                    <div style={{ marginBottom: '20px' }}>
                        {props.dataElements}
                    </div>
                    <div className={styles.signingCaption} style={{ marginBottom: '20px' }}>
                        I have reviewed, acknowledge, accept, and agree with the information presented herein.
                    </div>
                    <form autoComplete="off" className={styles.form} onSubmit={(e) => onSubmitClick(e)} noValidate>
                        <div className={styles.inputContainer}>
                            <div className={styles.formGroup}>
                                <div className={styles.labelGroup}>
                                    <label htmlFor="email" className={styles.inputLabelv4}>
                                        Email Address
                                    </label>
                                </div>

                                <input
                                    id="email"
                                    className={`${styles.inputv4} ${props.loginEmailError && styles.inputErrorv4}`}
                                    type="email"
                                    name="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    autoFocus
                                    readOnly={true}
                                />
                                {props.loginEmailError && <span className={styles.errorv4}>{props.loginEmailError}</span>}
                            </div>

                            <div className={styles.formGroup}>
                                <div className={styles.labelGroup}>
                                    <label htmlFor="password" className={styles.inputLabelv4}>
                                        {'Password'}
                                    </label>
                                </div>
                                <label className={`${styles.passowordInput} ${passwordError && styles.passowordInputError}`}>
                                    <input
                                        id="password"
                                        type={passwordType ? 'password' : 'text'}
                                        name="password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        autoFocus
                                    />
                                    <FontAwesomeIcon
                                        icon={passwordType ? faEye : faEyeSlash}
                                        className={styles.passwordIcon}
                                        onClick={togglePasswordVisibility}
                                    />
                                </label>
                                {passwordError && <span className={styles.errorv4}>{passwordError}</span>}
                                <Link to={{ pathname: '/forgot-password', state: { email } }} className={styles.forgotPasswordV4}>Forgot Password?</Link>
                            </div>
                        </div>
                        {loginErrorState && <span className={styles.errorv4}>{loginErrorState}</span>}
                        {props.keymasterSigningError && <pre className={styles.errorv4}>{props.keymasterSigningError}</pre>}


                        <div className={styles.formGroup}>
                            <button type="submit" className={styles.actionButtonv4} >
                                {'Next'}
                            </button>
                        </div>
                    </form >
                </div>
            }
        </LoginLayout >
    );
};

const mapStateToProps = (state, props) => ({
    clientData: lodash.get(state, 'application.config', {}),
    loginErrorState: lodash.get(state, 'loginError', false),
    loginEmailError: lodash.get(state, 'loginEmailError', false),
    showPassword: lodash.get(state, 'showPassword', false),
    keymasterSigningError: lodash.get(state, 'keymasterSigningError', false),

});

export default connect(mapStateToProps, { ssoSettingPin, loginError, setPasswordResetEmailSent, keymasterSign })(NewUserRegistrationTasks);
